module.exports = __webpack_public_path__ + "img/topic-hero.ca299c36.jpg";